import React from "react";

export default function Settings (){
  return (
    <div className="flex min-h-[calc(100vh-5rem)] items-center justify-center bg-gradient-to-br from-slate-50 via-white to-slate-100 px-6 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950">
      <div className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-10 text-center shadow-xl dark:border-slate-800 dark:bg-slate-900">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-blue-100 dark:bg-blue-900/30">
          <span className="text-4xl">🚧</span>
        </div>

        <h1 className="mt-6 text-3xl font-bold text-slate-900 dark:text-white">
          Settings
        </h1>

        <p className="mt-3 text-slate-600 dark:text-slate-400">
          This module is currently under development.
        </p>

        <div className="mt-8 flex items-center justify-center gap-3 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 dark:border-blue-900 dark:bg-blue-900/20">
          <span className="relative flex h-3 w-3">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-blue-500 opacity-75"></span>
            <span className="relative inline-flex h-3 w-3 rounded-full bg-blue-600"></span>
          </span>

          <span className="text-sm font-medium text-blue-700 dark:text-blue-300">
            Development in Progress...
          </span>
        </div>

      </div>
    </div>
  );
};